import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef, DialogService } from '@icc/ui';
import { ComplaintParty } from 'libs/b2b/shared/src/lib/models/complaint-party';
import { ComplaintMapDialogComponent, ComplaintMapDialogData } from '../complaint-map-dialog/complaint-map-dialog.component';

@Component({
    selector: 'icc-complaint-user-preview-dialog',
    templateUrl: './complaint-user-preview-dialog.component.html',
    styleUrls: ['./complaint-user-preview-dialog.component.scss'],
})
export class ComplaintUserPreviewDialogComponent {

    constructor(
        private dialogRef: DialogRef,
        private dialogService: DialogService,
        @Inject(DIALOG_DATA)
        public data: {
            user: ComplaintParty;
            userType: string;
            responsibleUser: any;
            assignedUser: any;
            locationDescription?: string;
            locationSource?: 'address' | 'manual';
            locationPartialMatchConfirmed?: boolean;
            latitude?: number;
            longitude?: number;
            apiLoaded?: boolean;
        },
    ) {}

    close() {
        this.dialogRef.close();
    }

    openMapDialog() {
        const dialogData: ComplaintMapDialogData = {
            initialPosition: this.installationAddress || undefined
        };

        this.dialogService.open(ComplaintMapDialogComponent, { data: dialogData });
    }

    get installationAddress() {
        if (this.data.latitude && this.data.longitude) {
            return {
                lat: this.data.latitude,
                lng: this.data.longitude,
            };
        }
        return null;
    }
}
